<template>
  <dashboard-component></dashboard-component>
</template>

<script>
import DashboardComponent from '@/components/general/DashboardComponent'
import { mapMutations } from 'vuex'

export default {
    components: {DashboardComponent},
    name:"Dashboard",
    methods: {        
      ...mapMutations([
          'SET_BREADCRUMB'
      ]),
      setBreadcrumb: function(){
        this.SET_BREADCRUMB(this.$route.meta.breadcrumb)
      }
    },
    mounted: function(){
        this.setBreadcrumb()
    }
  }
</script>